module.exports = __webpack_public_path__ + "static/media/knearcontent1.41d038aa.PNG";